import React, { useState } from "react";
import Box from "react-raster";
import { Heading, Radio } from "src/components";
import { theme } from "src/config";

export const RadioSection = () => {
  const [radioChecked, setRadioChecked] = useState("");

  return (
    <Box gridRowGap={theme.layout.gutterSmall} >
      <Heading weight="normal" type="h3" color="black">
        Radio
      </Heading>
      <Box>
        <hr/>
      </Box>
        {["One", "Two", "Three", "Four", "Disabled"].map((option: string) => (
          <Radio
            key={option}
            checked={radioChecked === option}
            disabled={option == "Disabled"}
            value={option}
            name="something"
            onClick={() => setRadioChecked(option)}
          />
        ))}
    </Box>

  );
};




{/* <Radio
    key={'asd'}
    checked={active}
    value="value"
    name="Group"
    onClick={setActive}
  />
 */}